import type { DayPlanQuery } from '@ctms/contracts';

export const visitQueryKeys = {
  all: ['visits'] as const,
  /** Day plan of one trial — keyed by the whole query so a new day or page reloads it. */
  dayPlan: (filters: DayPlanQuery) => [...visitQueryKeys.all, 'day-plan', filters] as const,
  /**
   * Every day plan of every trial — for invalidation only. Booking a visit date
   * (REQ-VIS-015) can move a row into the plan of ANY day, and the writer does
   * not know which day the coordinator is looking at, so the whole family is
   * refreshed by prefix instead of guessing one concrete day.
   */
  dayPlans: () => [...visitQueryKeys.all, 'day-plan'] as const,
  /**
   * Working list of ONE visit (REQ-VIS-045) — keyed by the patient visit, because
   * the list mixes the executions saved on that visit with the visit's pattern.
   */
  procedureWorkList: (patientVisitId: number) =>
    [...visitQueryKeys.all, 'procedure-work-list', patientVisitId] as const,
  /**
   * Catalogue of additional procedures of one trial (REQ-VIS-040) — the source
   * list of "add outside the pattern" (REQ-VIS-050). Changes rarely, so it is
   * keyed per trial instead of per visit.
   */
  procedureCatalogue: (trialId: number) =>
    [...visitQueryKeys.all, 'procedure-catalogue', trialId] as const,
  /**
   * OPEN to-do tasks of one enrollment (REQ-VIS-008) — keyed by the
   * participation, because a task hangs on the enrollment, never on a visit.
   */
  patientTasks: (enrollmentId: number) =>
    [...visitQueryKeys.all, 'patient-tasks', enrollmentId] as const,
  /** Kits registered at ONE visit (REQ-KIT-013..022). */
  visitKits: (patientVisitId: number) =>
    [...visitQueryKeys.all, 'visit-kits', patientVisitId] as const,
  /** Personnel registered at ONE visit (REQ-VIS-027, #32). */
  visitPersonnel: (patientVisitId: number) =>
    [...visitQueryKeys.all, 'visit-personnel', patientVisitId] as const,
};